import { HasId } from '../../interfaces';

export class TeamTypeahead implements HasId {
    public id: number;
    public name: string;
}


// WEBPACK FOOTER //
// ./src/models/typeaheads/TeamTypeahead.tsx